'use client';

import { useEffect } from 'react';
import { MAINTENANCE_STATUS_API_PATH, MAINTENANCE_STATUS_POLL_INTERVAL_MS, MAINTENANCE_STATUS_URL } from '@/features/maintenance/constants';
interface MaintenanceApiResponse {
  isMaintenanceActive?: boolean;
}
export default function MaintenanceStatusPoller() {
  useEffect(() => {
    let isUnmounted = false;
    const checkMaintenanceStatus = async () => {
      try {
        const response = await fetch(MAINTENANCE_STATUS_API_PATH, {
          cache: 'no-store'
        });
        if (!response.ok) {
          return;
        }
        const status = (await response.json()) as MaintenanceApiResponse;
        if (!isUnmounted && status.isMaintenanceActive) {
          globalThis.location.replace(MAINTENANCE_STATUS_URL);
        }
      } catch {
        // Fail open when the maintenance check cannot be completed.
      }
    };
    void checkMaintenanceStatus();
    const intervalId = globalThis.setInterval(() => {
      void checkMaintenanceStatus();
    }, MAINTENANCE_STATUS_POLL_INTERVAL_MS);
    return () => {
      isUnmounted = true;
      globalThis.clearInterval(intervalId);
    };
  }, []);
  return null;
}